let path = `https://browardstormviewerblobs.z13.web.core.windows.net/public`;

export const getNewLegendContent = (resultantArray) => {
 return `${`
                      <div style="background-color: white;">
                        <div class="esri-legend__service">
                          <h3 aria-level="3" class="esri-widget__heading esri-legend__service-label" role="heading">
                            Flooding Depth
                          </h3>
                           ${
                            resultantArray.length === 1
                             ? `<h3
                             aria-level="3"
                             class="esri-widget__heading esri-legend__service-label"
                             role="heading"
                            >
                             ${
                              resultantArray[0].includes("Patch")
                               ? resultantArray[0].split(" Patch").join("")
                               : resultantArray[0]
                             }
                            </h3>`
                             : `<div></div>`
                           }
                          <div class="esri-legend__layer-table esri-legend__layer-table--size-ramp">
                            <div class="esri-legend__layer-body">
                              <div class="esri-legend__layer-row">
                                <div class="esri-legend__layer-cell esri-legend__layer-cell--symbols">
                                  <img 
                                    alt="< 6 in" 
                                    aria-label="< 6 in" border="0" 
                                    class="esri-legend__symbol" 
                                    height="20" 
                                    width="20" 
                                    src="${path}/less-than-6in.png" 
                                    style="opacity:0.4;"
                                  />
                                </div>
                                <div class="esri-legend__layer-cell esri-legend__layer-cell--info">
                                  < 6 in
                                </div>
                              </div>
                            <div class="esri-legend__layer-row">
                              <div class="esri-legend__layer-cell esri-legend__layer-cell--symbols">
                                <img
                                  alt="6 in - 1 ft"
                                  aria-label="6 in - 1 ft"
                                  border="0"
                                  class="esri-legend__symbol"
                                  height="20"
                                  width="20"
                                  src="${path}/btwn-6in-1ft.png"
                                  style="opacity:0.4;"
                                />
                              </div>
                              <div class="esri-legend__layer-cell esri-legend__layer-cell--info">
                                6 in - 1 ft
                              </div>
                            </div>
                            <div class="esri-legend__layer-row">
                              <div class="esri-legend__layer-cell esri-legend__layer-cell--symbols">
                                <img
                                  alt="1 ft - 2 ft"
                                  aria-label="1 ft - 2 ft"
                                  border="0"
                                  class="esri-legend__symbol"
                                  height="20"
                                  width="20"
                                  src="${path}/btwn-1ft-2ft.png"
                                  style="opacity:0.4;"
                                />
                              </div>
                              <div class="esri-legend__layer-cell esri-legend__layer-cell--info">
                                1 ft - 2 ft
                              </div>
                            </div>
                            <div class="esri-legend__layer-row">
                              <div class="esri-legend__layer-cell esri-legend__layer-cell--symbols">
                                <img
                                  alt="> 2 ft"
                                  aria-label="> 2 ft"
                                  border="0"
                                  class="esri-legend__symbol"
                                  height="20"
                                  width="20"
                                  src="${path}/greater-than-2ft.png"
                                  style="opacity: 0.4;"
                                />
                              </div>
                              <div class="esri-legend__layer-cell esri-legend__layer-cell--info">
                                > 2 ft
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>`}`;
};

export const legendContent = `${`
                      <div style="background-color: white;">
                        <div class="esri-legend__service">
                          <h3 aria-level="3" class="esri-widget__heading esri-legend__service-label" role="heading">
                            Flooding Depth
                          </h3>
                          <div class="esri-legend__layer-table esri-legend__layer-table--size-ramp">
                            <div class="esri-legend__layer-body">
                              <div class="esri-legend__layer-row">
                                <div class="esri-legend__layer-cell esri-legend__layer-cell--symbols">
                                  <img 
                                    alt="< 6 in" 
                                    aria-label="< 6 in" border="0" 
                                    class="esri-legend__symbol" 
                                    height="20" 
                                    width="20" 
                                    src="${path}/less-than-6in.png" 
                                    style="opacity:0.4;"
                                  />
                                </div>
                                <div class="esri-legend__layer-cell esri-legend__layer-cell--info">
                                  < 6 in
                                </div>
                              </div>
                            <div class="esri-legend__layer-row">
                              <div class="esri-legend__layer-cell esri-legend__layer-cell--symbols">
                                <img
                                  alt="6 in - 1 ft"
                                  aria-label="6 in - 1 ft"
                                  border="0"
                                  class="esri-legend__symbol"
                                  height="20"
                                  width="20"
                                  src="${path}/btwn-6in-1ft.png"
                                  style="opacity:0.4;"
                                />
                              </div>
                              <div class="esri-legend__layer-cell esri-legend__layer-cell--info">
                                6 in - 1 ft
                              </div>
                            </div>
                            <div class="esri-legend__layer-row">
                              <div class="esri-legend__layer-cell esri-legend__layer-cell--symbols">
                                <img
                                  alt="1 ft - 2 ft"
                                  aria-label="1 ft - 2 ft"
                                  border="0"
                                  class="esri-legend__symbol"
                                  height="20"
                                  width="20"
                                  src="${path}/btwn-1ft-2ft.png"
                                  style="opacity:0.4;"
                                />
                              </div>
                              <div class="esri-legend__layer-cell esri-legend__layer-cell--info">
                                1 ft - 2 ft
                              </div>
                            </div>
                            <div class="esri-legend__layer-row">
                              <div class="esri-legend__layer-cell esri-legend__layer-cell--symbols">
                                <img
                                  alt="> 2 ft"
                                  aria-label="> 2 ft"
                                  border="0"
                                  class="esri-legend__symbol"
                                  height="20"
                                  width="20"
                                  src="${path}/greater-than-2ft.png"
                                  style="opacity: 0.4;"
                                />
                              </div>
                              <div class="esri-legend__layer-cell esri-legend__layer-cell--info">
                                > 2 ft
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>`}`;
